import React, { Component } from 'react'
import AnchorLink from 'react-anchor-link-smooth-scroll'

export default class ScrollTop extends Component{

	constructor(props){
		super(props)
		this.state = { visible: false }
	}

	scrollToTop(){
		if (typeof window !== 'undefined') {
			window.scroll(0, 0)
		}
	}

	fireOnScroll = (event) => {
    	if (typeof window !== 'undefined') {
	    	if(window.scrollY > 50){
	    		this.setState({visible: true})
	    	}
	    	else
	    		this.setState({visible: false})
	    }
	}

	componentDidMount() {
		if (typeof window !== 'undefined') {
	    	window.addEventListener('scroll', this.fireOnScroll)
	    }
	}

	componentWillUnmount() {
		if (typeof window !== 'undefined') {
	    	window.removeEventListener('scroll', this.fireOnScroll)
	    }
	}

	render(){
		return(
			<div className="scrolltop-container">
				<AnchorLink 
					href={`#pagetop`} 
					className={`scrolltop-button ${(this.state.visible ? "visible" : "hidden")}`}
				>
					Haut<br/>de page
				</AnchorLink>

			</div>
		)
	}
}